export default class SeoResource {
    public static toAltText(text: string): string {
        try {
            return text.replace(/\s+/g, '_');
        } catch (error) {
            return '';
        }
    }
}
